<mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor" [trackBy]="trackByFunction" [expansionKey]="expansionKeyFunction" >
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (click)="nodeClicked($event, node)">
    <button matIconButton disabled></button>
    <button mat-button>{{node.label}}</button>
    @if(node.extraData.sameOwner) {
      <mat-icon class='same-email-warning' title="{{'dialog.owner-list.tree.same-owner' | translate}}">warning</mat-icon>
    }
  </mat-tree-node>
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodeToggle
                 [cdkTreeNodeTypeaheadLabel]="node.item">
    <button matIconButton
            [attr.aria-label]="'Toggle ' + node.item" matTreeNodeToggle>
      <mat-icon class="mat-icon-rtl-mirror">
        {{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    <div (click)="nodeClicked($event, node)">
      <button mat-button>{{node.label}}</button>
      @if(node.extraData.sameEmail) {
        <mat-icon class='same-email-warning' title="{{'dialog.owner-list.tree.same-owner' | translate}}">warning</mat-icon>
      }
    </div>
  </mat-tree-node>
</mat-tree>
